"use client";

import { lazy } from "react";
import type { ToolUIMeta, ToolUIRegistry } from "../../tool-renderer";

/**
 * Views for the `concur-travel` capability (beta travel search). Each result
 * row deeplinks to the chosen flight/hotel/car in Concur Travel, where the
 * user books — the tools themselves never write.
 */
export const concurTravelToolRegistry = {
  concurTravelSearchFlights: {
    kind: "standalone",
    category: "research",
    view: lazy(() =>
      import("./views").then(({ ConcurTravelSearchFlightsToolView }) => ({
        default: ConcurTravelSearchFlightsToolView,
      }))
    ),
  },
  concurTravelSearchHotels: {
    kind: "standalone",
    category: "research",
    view: lazy(() =>
      import("./views").then(({ ConcurTravelSearchHotelsToolView }) => ({
        default: ConcurTravelSearchHotelsToolView,
      }))
    ),
  },
  concurTravelSearchRentalCars: {
    kind: "standalone",
    category: "research",
    view: lazy(() =>
      import("./views").then(({ ConcurTravelSearchRentalCarsToolView }) => ({
        default: ConcurTravelSearchRentalCarsToolView,
      }))
    ),
  },
  concurTravelSearchTrip: {
    kind: "standalone",
    category: "research",
    view: lazy(() =>
      import("./views").then(({ ConcurTravelSearchTripToolView }) => ({
        default: ConcurTravelSearchTripToolView,
      }))
    ),
  },
  concurTravelGetHotelRooms: {
    kind: "standalone",
    category: "research",
    view: lazy(() =>
      import("./views").then(({ ConcurTravelGetHotelRoomsToolView }) => ({
        default: ConcurTravelGetHotelRoomsToolView,
      }))
    ),
  },
  concurTravelListTrips: {
    kind: "standalone",
    category: "research",
    view: lazy(() =>
      import("./views").then(({ ConcurTravelListTripsToolView }) => ({
        default: ConcurTravelListTripsToolView,
      }))
    ),
  },
  concurTravelGetTrip: {
    kind: "standalone",
    category: "research",
    view: lazy(() =>
      import("./views").then(({ ConcurTravelGetTripToolView }) => ({
        default: ConcurTravelGetTripToolView,
      }))
    ),
  },
} satisfies ToolUIRegistry;

/**
 * Namespaced variant keyed by the progressive-disclosure inner-tool name
 * `concur-travel_${toolName}` — without it a PD tool part falls back to the
 * generic JSON view. The bare-name entries above stay in the static tier,
 * which `AllToolNames` still requires. See ADR-057.
 */
export const concurTravelProgressiveDisclosureToolRegistry: Record<
  string,
  ToolUIMeta
> = Object.fromEntries(
  Object.entries(concurTravelToolRegistry).map(([name, meta]) => [
    `concur-travel_${name}`,
    meta,
  ])
);
